import Avatar from './Avatar';

export default {
  install(Vue) {
    Vue.use(Avatar);
  },
};
